import { getComponentCategoryData } from "@/util/qualityUtil/componentCategory"; // 零部件类别
import { severityList, severityListKD } from "@/util/qualityUtil/severityLevels"; // 严重程度
import { requiredLocation } from "@/util/qualityUtil/requiredLocation"; // 必填校验定位
// import { kdAuditHistoryList } from "@/api/qualityKD";
// import { auditHistoryList } from "@/api/feedback";
import { getCheckPartApi } from "@/api/feedback"; // 获取疑似/祸首件名称
import { dealerCancel, kdDealerCancel } from "@/util/qualityUtil/dealerAudit";  // 取消
export default {
  data() {
    return {
      componentCategoryList: [], // 零部件类别
      componentCategoryName: "", // 零部件类别map
      severityData: [], //严重程度
      severityDataKD: [], //KD严重程度
      // provisionalMeasures: "", // 临时措施
    };
  },
  methods: {
    // 获取零部件类别和严重程度
    getTypeList() {
      getComponentCategoryData(this);
      this.severityData = severityList;
      this.severityDataKD = severityListKD;
    },
    // 必填提示定位
    getErrorLocation() {
      this.$nextTick(() => {
        requiredLocation()
      });
    },
    // 获取疑似/祸首件名称
    async getCheckPart() {
      const res = await getCheckPartApi({
        data: {
          suspectPartNumber: this.form.suspectPartNumber,
        },
      });
      if(res.status == 0){
        var partName = ""
        if(this.$i18n.locale == 'zh') {
          partName = res.data.name
        } else {
          partName = res.data[this.$i18n.locale]
        }
        this.form.suspectPartName = partName
        if (!partName) {
          this.$DonMessage.warning(this.$t("restockInfo.partsError", { code: this.form.suspectPartNumber }));
        } else {
          this.$DonMessage.success(this.$t("restockInfo.partsSuccess"));
        }
      }
    },
    // 整车取消
    getDealerCancel() {
      dealerCancel(this, this.problemData, "cancel")
    },
    // KD取消
    getKDDealerCancel() {
      kdDealerCancel(this, this.problemData, "cancel")
    },
    // 获取反馈单信息
    getFeedbackDetail() {
      const submitData = JSON.parse(JSON.stringify(this.form));
      // 保养记录
      let recordObj ={
        engineRecordList:this.form.engineRecordList,
        transmissionRecordList:this.form.transmissionRecordList,
      }
      submitData.maintenanceRecord = JSON.stringify(recordObj);
      submitData.maintenanceRecordInfo = recordObj;
      // 是否重点问题
      this.form.importantType == 0 && (submitData.importantDescribe = "");
      // 是否有维修措施
      this.form.serviceMeasure == 0 && (submitData.marketService = "");
      // 图片和视频 选择否 置空附件备注信息
      this.form.faultVideo == 0 && (this.form.faultVideoFiles = "");
      this.form.faultCode == 0 && (submitData.faultCodeRemark = this.form.faultCodeFiles = "");
      this.form.otherInstructions == 0 && (submitData.otherRemark = this.form.otherFiles = "");
      // 3. 统一处理附件转字符串（提取公共方法）
      const stringifyIfNotEmpty = (arr) => (Array.isArray(arr) && arr.length) ? JSON.stringify(arr) : "";
      // 附件信息转字符串
      submitData.faultCommonFiles = stringifyIfNotEmpty(this.form.faultCommonFiles);
      submitData.faultVideoFiles = stringifyIfNotEmpty(this.form.faultVideoFiles);
      submitData.faultCodeFiles = stringifyIfNotEmpty(this.form.faultCodeFiles);
      submitData.otherFiles = stringifyIfNotEmpty(this.form.otherFiles);
      
      submitData["languageType"] = this.$i18n.locale;
      return submitData
    },
    // 提示附件正在上传
    fileUploadTip() {
      if(!this.getFileUploadTip()){
        return
      }
    },
    // 获取临时措施
    // async getMeasureDetail() {
    //   const res = await auditHistoryList({
    //     data: { questionId: this.problemData.questionId },
    //   });
    //   var recordList = res.data;
    //   recordList.forEach((item) => {
    //     if (item.provisionalMeasures) {
    //       this.provisionalMeasures = item.provisionalMeasures;
    //     }
    //   });
    // },
    // 获取临时措施
    // async kdGetMeasureDetail() {
    //   const res = await kdAuditHistoryList({
    //     data: { questionId: this.problemData.questionId },
    //   });
    //   var recordList = res.data;
    //   recordList.forEach((item) => {
    //     if (item.provisionalMeasures) {
    //       this.provisionalMeasures = item.provisionalMeasures;
    //     }
    //   });
    // },
  },
};
